<template>
  <div :class="margin" v-if="note">
    <v-card flat v-if="showHead">
      <v-card-text class="pa-0 d-flex justify-space-between">
        <div
          v-if="note.author_info"
          class="note--title text-truncate"
          style="max-width: 80%;"
        >
          {{ authorDisplayName }}
        </div>
        <div v-if="!completionDate" class="text-nowrap text-right">
          {{ note.created | moment("DD MMM YYYY") }}
        </div>
        <div v-if="completionDate" class="text-nowrap text-right">
          {{ completionDate | moment("DD MMM YYYY") }}
        </div>
      </v-card-text>
    </v-card>

    <div class="text-subtitle-1 d-flex" v-if="showHead">
      <pre v-if="!isNoteServiceList" class="mt-1 note-content">{{
        cleanContent
      }}</pre>
      <div v-if="isNoteServiceList" class="mt-1">
        <service-list-item
          v-for="listItem in note.content"
          :item="listItem"
          :key="listItem.uuid"
        />
      </div>
    </div>

    <v-list v-if="showLegs && attachments.length">
      <attachment
        :attachment="attachment"
        :key="attachment.uuid"
        v-for="attachment in attachments"
      ></attachment>
    </v-list>
  </div>
</template>

<script>
import Attachment from "@/components/Attachment.vue";
import ServiceListItem from "@/components/ServiceListItem.vue";
import { mapState } from "vuex";

export default {
  name: "entry-note",
  components: {
    Attachment,
    ServiceListItem,
  },
  props: {
    completionDate: null,
    note: Object,
    dealer: Object,
    showHead: {
      type: Boolean,
      default: true,
    }, // show note content & author
    showLegs: {
      type: Boolean,
      default: true,
    }, // show attachments
  },
  data: () => ({}),
  computed: {
    ...mapState({
      accessToken: (s) => s.accessToken,
      userBoatId: (s) => s.userBoatId,
    }),
    isNoteServiceList: function() {
      return this.note.contentType && this.note.contentType === "SERVICE_LIST";
    },
    authorDisplayName: function() {
      // HACK: until I get better data from server
      if (!this.note.author_info) {
        return "";
      }

      if (this.note.author_info.type === "PARTNER") {
        return this.note.author_info.name;
      } else if (this.note.author_info.type === "USER") {
        if (this.note.author_info.name) {
          return this.$t("components.entryNote.ManualEntryBy", {
            author_name: this.note.author_info.name,
          });
        } else {
          return this.$t("components.entryNote.manualEntry");
        }
      } else {
        return this.note.author_info.name;
      }
    },
    margin: function() {
      if (this.showHead === false) {
        return "mb-2";
      } else if (this.showLegs === false) {
        return "mt-0";
      } else {
        return "my-2";
      }
    },
    attachments: function() {
      if (this.note && this.note.attachments) {
        return this.note.attachments;
      } else {
        return [];
      }
    },
    cleanContent: function() {
      return this.note.content.trim();
    },
  },
};
</script>

<style scoped>
.note-content {
  font-family: inherit;
  white-space: pre-wrap;
  word-break: keep-all;
}

.text-nowrap {
  white-space: nowrap;
}

.note--title {
  font-weight: 500;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  color: #1e1e1e;
}
</style>
